import { ShareGifMenu } from "components/UI/ShareMenu/ShareGifMenu";
import { AddToNichePopup } from "components/niches/AddToNichePopup";
import { ReportPopup } from "components/UI/Popups/Report";
import { GifPreferencePopup } from "components/UI/Popups/GifPreferencePopup";
import { AddToCollectionPopup } from "components/UI/Popups/Collections/AddToCollectionPopup";
import { MoreMenu } from "components/popups/MoreMenu";
import { EditNichesDialog } from "components/dialogs/EditNichesDialog";
import { EditNichePopup } from "components/popups/EditNichePopup";
import AuthPopup from "components/UI/Popups/AuthPopup/AuthPopup";
import ResponseMessage from "components/UI/ResponseMessage";
import { usePopupManagerState } from "./usePopupManagerState";

export const PopupManager: React.FC = () => {
  const {
    isNicheOpen,
    isBookmarkOpen,
    isReportOpen,
    isGifPrefsOpen,
    showShareMenu,
    isMenuOpen,
    anchorEl,
    editNichesDialog,
    currentPopupGif,
    handleHideGif,
    handleManageClick,
    handleOpenEditNichesDialog,
    handleToggleEditNiche,
    toggleCollection,
    toggleNiche,
    toggleReport,
    toggleShareMenu,
    toggleGifPrefs,
    handleCloseMenu,
    handleCloseShare,
    handleCloseEditNichesDialog,
    sourceId,
    isPopupInFs,
    currentPopupNiche,
    editNicheOpen,
    isOpenAuthModal
  } = usePopupManagerState();

  return (
    <>
      {isMenuOpen && (
        <MoreMenu
          handleHideGif={handleHideGif}
          handleManageClick={handleManageClick}
          handleOpenEditNichesDialog={handleOpenEditNichesDialog}
          toggleCollection={toggleCollection}
          toggleNiche={toggleNiche}
          toggleReport={toggleReport}
          toggleShareMenu={toggleShareMenu}
          toggleGifPrefs={toggleGifPrefs}
          handleCloseMenu={handleCloseMenu}
          gif={currentPopupGif}
          anchorEl={anchorEl}
          fullscreen={isPopupInFs}
        />
      )}

      {showShareMenu && (
        <ShareGifMenu
          gif={currentPopupGif}
          anchorEl={anchorEl}
          onClose={handleCloseShare}
          fullscreen={isPopupInFs}
          context={sourceId}
        />
      )}

      {isNicheOpen && (
        <AddToNichePopup
          isOpen={isNicheOpen}
          togglePopup={toggleNiche}
          gifId={currentPopupGif.id}
        />
      )}

      {isReportOpen && (
        <ReportPopup
          isOpen={isReportOpen}
          togglePopup={toggleReport}
          gifId={currentPopupGif.id}
          handleMainPopup={toggleReport}
        />
      )}

      {isBookmarkOpen && (
        <AddToCollectionPopup
          isOpen={isBookmarkOpen}
          togglePopup={toggleCollection}
          gifId={currentPopupGif.id}
          context={sourceId}
        />
      )}

      {editNichesDialog.canShow && editNichesDialog.role && (
        <EditNichesDialog
          gifId={currentPopupGif.id}
          role={editNichesDialog.role}
          onClose={handleCloseEditNichesDialog}
        />
      )}

      {isGifPrefsOpen && (
        <GifPreferencePopup
          onClose={toggleGifPrefs}
          isOpen={isGifPrefsOpen}
          gifId={currentPopupGif.id}
          sexuality={currentPopupGif?.sexuality || []}
        />
      )}

      {editNicheOpen && (
        <EditNichePopup
          isOpen={editNicheOpen}
          onClose={handleToggleEditNiche}
          niche={currentPopupNiche}
        />
      )}

      {isOpenAuthModal && <AuthPopup />}

      <ResponseMessage />
    </>
  );
};
